import { render, staticRenderFns } from "./WorkModal.vue?vue&type=template&id=bab372d8&scoped=true"
import script from "../../../scripts/partials/WorkModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/WorkModal.js?vue&type=script&lang=js&external"
import style0 from "./WorkModal.vue?vue&type=style&index=0&id=bab372d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab372d8",
  null
  
)

export default component.exports